// import React, { createContext, useEffect, useState } from "react";
// import Cookies from "js-cookie"; // Import Cookies if necessary
import { createContext } from "react";

export const AppContext = createContext();
export const SlotsContext = createContext();
export const ProvideFeedback = createContext();
